import React from 'react';
import { Table2, LayoutGrid, Printer } from 'lucide-react';

interface ViewToggleProps {
  view: 'matrix' | 'visual';
  onViewChange: (view: 'matrix' | 'visual') => void;
  onPrint: () => void;
}

export const ViewToggle: React.FC<ViewToggleProps> = ({ view, onViewChange, onPrint }) => {
  return (
    <div className="flex items-center gap-2 mb-4">
      <div className="bg-gray-100 p-1 rounded-lg flex">
        <button
          onClick={() => onViewChange('matrix')}
          className={`px-3 py-2 rounded-md flex items-center gap-2 ${
            view === 'matrix' 
              ? 'bg-white shadow text-blue-600' 
              : 'text-gray-600 hover:text-gray-900'
          }`}
        >
          <Table2 className="w-4 h-4" />
          <span>Table View</span>
        </button>
        <button
          onClick={() => onViewChange('visual')}
          className={`px-3 py-2 rounded-md flex items-center gap-2 ${
            view === 'visual' 
              ? 'bg-white shadow text-blue-600' 
              : 'text-gray-600 hover:text-gray-900'
          }`}
        >
          <LayoutGrid className="w-4 h-4" />
          <span>Visual View</span>
        </button>
      </div>
      
      <button
        onClick={onPrint}
        className="px-3 py-2 rounded-md bg-gray-100 text-gray-600 hover:text-gray-900 flex items-center gap-2"
      >
        <Printer className="w-4 h-4" />
        <span>Print</span>
      </button>
    </div>
  );
};